import { render, staticRenderFns } from "./extend-booking-summary.vue?vue&type=template&id=d0986036&scoped=true&"
import script from "./extend-booking-summary.vue?vue&type=script&lang=js&"
export * from "./extend-booking-summary.vue?vue&type=script&lang=js&"
import style0 from "./extend-booking-summary.vue?vue&type=style&index=0&id=d0986036&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0986036",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
